import { FC } from 'react';

import LegacyCard from 'components/LegacyCard';
import Row from 'components/Row';
import Header from 'features/Onboarding/components/Header';
import RegulatedInstitutionDescription from 'features/Onboarding/legacy/components/RegulatedInstitutionDescription';
import { CTAButton } from 'features/Onboarding/legacy/Pages/styles';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';

import headerImage from '../../assets/headerPersonalStatus.svg';
import usePersonalStatusHandlers from '../../hooks/usePersonalStatusHandlers';
import locales from './locales';
import {
  ErrorText,
  RadioButton,
  Section,
  SectionButtons,
  SectionLabel,
} from './styles';

const MORE_INFO_URL =
  'https://help.shine.fr/fr/articles/2912143-pourquoi-me-demande-t-on-si-j-ai-une-residence-fiscale-a-l-etranger';

const PersonalStatusPageContent: FC<
  ReturnType<typeof usePersonalStatusHandlers>
> = ({
  handleFormSubmit,
  hasForeignFiscalResidence,
  isSpecifiedUSPerson,
  loading,
  showForeignFiscalResidenceError,
  showUSSpecifiedPersonError,
  updateHasForeignFiscalResidence,
  updateIsSpecifiedUSPerson,
}) => (
  <form onSubmit={handleFormSubmit}>
    <OnboardingPageContent>
      <Header
        description={
          <RegulatedInstitutionDescription moreInfoLinkHref={MORE_INFO_URL} />
        }
        imageSrc={headerImage}
        title={locales.title}
      />

      <LegacyCard>
        <LegacyCard.Body>
          <Section>
            <SectionLabel>{locales.sectionLabelUsCitizen}</SectionLabel>

            <SectionButtons>
              <RadioButton
                // TODO(matt): Add role="radio" and related aria attributes when this is supported by sunbeam library
                data-testid="isSpecifiedUSPerson"
                onClick={() => updateIsSpecifiedUSPerson(true)}
                variant={isSpecifiedUSPerson === true ? 'primary' : 'secondary'}
              >
                {locales.buttonLabelYes}
              </RadioButton>

              <RadioButton
                data-testid="isNotSpecifiedUSPerson"
                onClick={() => updateIsSpecifiedUSPerson(false)}
                variant={
                  isSpecifiedUSPerson === false ? 'primary' : 'secondary'
                }
              >
                {locales.buttonLabelNo}
              </RadioButton>
            </SectionButtons>

            {showUSSpecifiedPersonError ? (
              <ErrorText>{locales.required}</ErrorText>
            ) : null}
          </Section>

          <Section>
            <SectionLabel>{locales.sectionLabelFiscalResidence}</SectionLabel>

            <SectionButtons>
              <RadioButton
                data-testid="hasForeignFiscalResidence"
                onClick={() => updateHasForeignFiscalResidence(true)}
                variant={
                  hasForeignFiscalResidence === true ? 'primary' : 'secondary'
                }
              >
                {locales.buttonLabelYes}
              </RadioButton>

              <RadioButton
                data-testid="hasNotForeignFiscalResidence"
                onClick={() => updateHasForeignFiscalResidence(false)}
                variant={
                  hasForeignFiscalResidence === false ? 'primary' : 'secondary'
                }
              >
                {locales.buttonLabelNo}
              </RadioButton>
            </SectionButtons>

            {showForeignFiscalResidenceError ? (
              <ErrorText>{locales.required}</ErrorText>
            ) : null}
          </Section>
        </LegacyCard.Body>

        <LegacyCard.Footer padding={['abs24', '0']}>
          <Row justifyContent="center">
            <CTAButton isLoading={loading} type="submit">
              {locales.nextButtonLabel}
            </CTAButton>
          </Row>
        </LegacyCard.Footer>
      </LegacyCard>
    </OnboardingPageContent>
  </form>
);

export default PersonalStatusPageContent;
